import { startBehaviors } from "../lib/behaviors"
import confirm from "../behaviors/confirm"

startBehaviors({ confirm })

// Signed-in pages are sent with no-store; if a browser still restores one from its back/forward
// cache, reload so the server decides what to show (after signing out, that's the sign-in page).
window.addEventListener("pageshow", (event) => {
  if (event.persisted) window.location.reload()
})
